"use strict";

const cssom = require("cssom");

class LinkStyleImpl {
  get sheet() {
    if (!this._cssStyleSheet) {
      this._cssStyleSheet = new cssom.CSSStyleSheet();
    }
    return this._cssStyleSheet;
  }
}

module.exports = {
  implementation: LinkStyleImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/nodes/LinkStyle-impl.js
// module id = SVba
// module chunks = 1